import { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface DialogContextType {
  isDialogOpen: boolean;
  openDialog: () => void;
  closeDialog: () => void;
}

const DialogContext = createContext<DialogContextType | undefined>(undefined);

export const DialogProvider = ({ children }: { children: ReactNode }) => {
  const [openDialogs, setOpenDialogs] = useState<number>(0);

  const openDialog = useCallback(() => {
    setOpenDialogs((prev) => prev + 1);
  }, []);

  const closeDialog = useCallback(() => {
    setOpenDialogs((prev) => Math.max(0, prev - 1));
  }, []);

  const isDialogOpen = openDialogs > 0;

  return (
    <DialogContext.Provider value={{ isDialogOpen, openDialog, closeDialog }}>
      {children}
    </DialogContext.Provider>
  );
};

export const useDialogState = () => {
  const context = useContext(DialogContext);
  if (context === undefined) {
    throw new Error('useDialogState must be used within a DialogProvider');
  }
  return context;
};
